import React from "react";
import "./Portfolio.css";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "ag-grid-enterprise";

import { connect } from "react-redux";

import * as Constants from "../../constants/Constants";
import * as Colors from "../../constants/Colors";
import * as Helpers from "../../global/Helpers";
import * as PDFGenerator from "../../global/PDFGenerator";
import * as utils from "../../global/utils";
import * as actions from "../../store/actionTypes";

import { FileEarmarkPdf, ArrowRepeat } from "react-bootstrap-icons";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { withTranslation } from "react-i18next";
import CustomReactComponent from "../shared/CustomReactComponent/CustomReactComponent";
import CustomPureReactComponent from "../shared/CustomPureReactComponent/CustomPureReactComponent";
import { debounce } from "@material-ui/core";
import BracketOrdersPopup from "./BracketOrdersPopup";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { signal } from "@preact/signals-react";
export const orderFromPortfolio = signal(false);

class PortfolioFromDB extends CustomPureReactComponent {
  constructor(props) {
    super(props);

    this.channel = new BroadcastChannel("fit_dataFeed_connect");
    localStorage
      .getItem(Constants.localStorageConstants.EnableTags)
      .toUpperCase() === "TRUE"
      ? (this.channel.onmessage = (res) => {
          if (res.data.to === "UpdateFromMarketWatch") {
            this.CheckMarketWAtchUpdateData(res.data.msg);
          }
        })
      : (this.channel.onmessage = (res) => {
          if (res.data.to === "MarketWatchUpdate")
            this.CheckMarketWAtchUpdateData(res.data.msg);
        });

    let enableRtl = false;
    if (props.i18n.language === "ar") {
      enableRtl = true;
    }
    var textAlignNO = "right";
    if (
      localStorage.getItem(Constants.localStorageConstants.company_name) ===
      "UNITED"
    ) {
      if (props.i18n.language === "ar") {
        textAlignNO = "right";
      } else {
        textAlignNO = "left";
      }
    }
    var isDarkMode = false;
    if (this.props.isDarkMode) {
      isDarkMode = true;
    } else {
      if (localStorage.getItem("theme") == "dark") {
        isDarkMode = true;
      }
    }
    let ColorsgreenNumber = isDarkMode
      ? Colors.greenNumberDarkTheme
      : Colors.greenNumber;
    this.state = {
      enableRtl: enableRtl,
      isGridReady: false,
      accounts: [
        {
          ALLOW_DERIV_TRADING: "",
          AccType: "",
          AccountDesc: "",
          AccountID: "",
          CL_BANK_ID: "",
          CL_BANK_ID2: "",
          CUR_CODE: "",
          ClientID: "",
          ClientNameA: "",
          ClientNameE: "",
          Email_Address: "",
          Exchange: "",
          Exchange_DESC_A: "",
          Exchange_DESC_E: "",
          IS_DEFAULT_ACC: "",
          IS_INTER: "",
          IS_Islamic: "",
          IS_MARGIN_ACC: "",
          IS_SAMEDAY: "",
          MainClientID: "",
          MainClientNameA: "",
          MainClientNameE: "",
          Mobile_NO: "",
          NIN: "",
        },
      ],
      selectedAccount: {
        ALLOW_DERIV_TRADING: "",
        AccType: "",
        AccountDesc: "",
        AccountID: "",
        CL_BANK_ID: "",
        CL_BANK_ID2: "",
        CUR_CODE: "",
        ClientID: "",
        ClientNameA: "",
        ClientNameE: "",
        Email_Address: "",
        Exchange: "",
        Exchange_DESC_A: "",
        Exchange_DESC_E: "",
        IS_DEFAULT_ACC: "",
        IS_INTER: "",
        IS_Islamic: "",
        IS_MARGIN_ACC: "",
        IS_SAMEDAY: "",
        MainClientID: "",
        MainClientNameA: "",
        MainClientNameE: "",
        Mobile_NO: "",
        NIN: "",
      },
      isAccountSelectedFromProps: false,
      profitLossData: null,
      totalHoldingCost: 0,
      totalMarketValue: 0,
      totalPL: 0,
      totalRealizedPL: 0,
      totalExpectedPL: 0,
      totalExpectedSellComm: 0,
      totalNetPL: 0,
      totalNetPortfolio: 0,
      style: {
        width: "calc(100% - 5px)",
        height: "100%",
        fontSize: "11px",
        overflow: "hidden",
      },
      rowHeight: 28,
      /* Columns */
      columnDefs: [
        {
          headerName: this.props.t("symbol"),
          field: "Symbol",
          tooltipField: "Symbol",
          cellStyle: function (params) {
            if (params.data.PProf > 0) {
              //mark values greater than 0 green
              return { color: ColorsgreenNumber, fontWeight: "bold" };
            } else if (params.data.PProf < 0) {
              //mark values less than 0 red
              return { color: Colors.redNumber, fontWeight: "bold" };
            } else {
              //No mark with values equal to 0
              return null;
            }
          },
          headerTooltip: this.props.t("symbol"),
        },
        {
          headerName: this.props.t("SymbolNameE"),
          field:
            props.i18n.language === "ar"
              ? "COMPANY_SHORT_A"
              : "COMPANY_SHORT_E",
          tooltipField:
            props.i18n.language === "ar"
              ? "COMPANY_SHORT_A"
              : "COMPANY_SHORT_E",
          headerTooltip: this.props.t("CompanyNameE"),
          hide:
            localStorage
              .getItem(Constants.localStorageConstants.Region)
              .toUpperCase() === "EGYPT" ||
            localStorage
              .getItem(Constants.localStorageConstants.company_name)
              .toUpperCase() === "SIFS"
              ? false
              : true,
        },
        {
          headerName: this.props.t("SymbolNameE"),
          field: props.i18n.language === "ar" ? "CompanyNameA" : "CompanyNameE",
          tooltipField:
            props.i18n.language === "ar" ? "CompanyNameA" : "CompanyNameE",
          headerTooltip: this.props.t("CompanyNameE"),
          hide:
            Helpers.getCompanyName() === "GLOBAL" ||
            Helpers.getCompanyName() === "UNITED"
              ? false
              : true,
        },
        {
          headerName: this.props.t("Lending"),
          width: 100,
          minWidth: 80,
          menuTabs: ["generalMenuTab", "gibberishMenuTab", "filterMenuTab"],
          field: "MV_WEIGHT",
          cellRenderer: "agAnimateShowChangeCellRenderer",

          hide:
            localStorage
              .getItem(Constants.localStorageConstants.Region)
              .toUpperCase() === "EGYPT"
              ? false
              : true,
          comparator: Helpers.numberSort,
          tooltipField: "MV_WEIGHT",
          headerTooltip: this.props.t("Lending"),
        },
        {
          headerName: this.props.t("Custodian"),
          field: props.i18n.language === "ar" ? "CUSTODIAN_A" : "CUSTODIAN_E",
          tooltipField:
            props.i18n.language === "ar" ? "CUSTODIAN_A" : "CUSTODIAN_E",
          headerTooltip: this.props.t("Custodian"),
          hide:
            localStorage
              .getItem(Constants.localStorageConstants.Region)
              .toUpperCase() === "EGYPT"
              ? false
              : true,
        },
        {
          headerName: this.props.t("qty"),
          field: "Qty",
          valueFormatter: this.numberFormatter,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: this.numberFormatter,
          headerTooltip: this.props.t("qty"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        {
          headerName: this.props.t("qtyT0"),
          field: "QTY_T0",
          valueFormatter: this.numberFormatter,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: Helpers.numberFormatter,
          headerTooltip: this.props.t("qtyT0"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
          hide:
            localStorage
              .getItem(Constants.localStorageConstants.Region)
              .toUpperCase() === "EGYPT"
              ? false
              : true,
        },
        {
          headerName: this.props.t("qtyT1"),
          field: "QTY_T1",
          valueFormatter: this.numberFormatter,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: Helpers.numberFormatter,
          headerTooltip: this.props.t("qtyT1"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
          hide:
            localStorage
              .getItem(Constants.localStorageConstants.Region)
              .toUpperCase() === "EGYPT"
              ? false
              : true,
        },
        {
          headerName: this.props.t("qtyT2"),
          field: "QTY_T2",
          valueFormatter: this.numberFormatter,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: Helpers.numberFormatter,
          headerTooltip: this.props.t("qtyT2"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
          hide:
            localStorage
              .getItem(Constants.localStorageConstants.Region)
              .toUpperCase() === "EGYPT"
              ? false
              : true,
        },
        {
          headerName: this.props.t("cost"),
          field: "PCost",
          valueFormatter: Helpers.agGridThreeDigitFormatValue,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: Helpers.agGridThreeDigitFormatValue,
          headerTooltip: this.props.t("cost"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        {
          headerName: this.props.t("NAV"),
          field: "PsValue",
          valueFormatter: this.numberFormatter,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: this.numberFormatter,
          headerTooltip: this.props.t("NAV"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        {
          headerName: this.props.t("breakevenPrice"),
          field: "EPrice",
          width: 60,
          minWidth: 60,
          valueFormatter: Helpers.agGridThreeDigitFormatValue,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: Helpers.agGridThreeDigitFormatValue,
          headerTooltip: this.props.t("breakevenPrice"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        // {
        //   headerName: this.props.t("closeprice"),
        //   field: "PrClosePrice",
        //   width: 40,
        //   minWidth: 40,
        //   cellRenderer: "agAnimateShowChangeCellRenderer",
        //   valueFormatter: Helpers.agGridThreeDigitFormatValue,
        //   tooltipComponent: "customTooltip",
        //   tooltipValueGetter: Helpers.agGridThreeDigitFormatValue,
        //   headerTooltip: this.props.t("closeprice"),
        //   cellStyle: {
        //     "text-align": textAlignNO,
        //     unicodeBidi: "plaintext",
        //   },
        // },
        {
          headerName: this.props.t("closeprice"),
          field: "PrClosePrice",
          width: 40,
          minWidth: 40,
          cellRenderer: "agAnimateShowChangeCellRenderer",
          valueFormatter: Helpers.agGridThreeDigitFormatValue,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: Helpers.agGridThreeDigitFormatValue,
          headerTooltip: this.props.t("closeprice"),
          cellClassRules: {
            "is-pos": (p) =>
              localStorage
                .getItem(
                  Constants.localStorageConstants.RealTimePortfolioUpdate
                )
                ?.toUpperCase() === "TRUE" && Number(p.data?.PPerc) > 0,

            "is-neg": (p) =>
              localStorage
                .getItem(
                  Constants.localStorageConstants.RealTimePortfolioUpdate
                )
                ?.toUpperCase() === "TRUE" && Number(p.data?.PPerc) < 0,
          },
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        {
          headerName: this.props.t("marketvaluePortfolio"),
          field: "NValue",
          width: 40,
          minWidth: 40,
          suppressCellFlash: true,
          cellRenderer: "agAnimateShowChangeCellRenderer",
          valueFormatter: this.numberFormatter,
          comparator: Helpers.numberSort,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: this.numberFormatter,
          headerTooltip: this.props.t("marketvaluePortfolio"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },

        {
          headerName: this.props.t("profitloss"),
          field: "PProf",
          suppressCellFlash: true,
          cellRenderer: "agAnimateShowChangeCellRenderer",
          valueGetter: function sumField(params) {
            return (
              Helpers.numberFormatterWithCommasAndDigits(params.data.PProf, 3) +
              "(" +
              Helpers.numberFormatterWithCommasAndDigits(params.data.PPerc, 3) +
              "%)"
            );
          },
          cellStyle: function (params) {
            if (params.data.PProf > 0) {
              //mark values greater than 0 green
              return {
                color: ColorsgreenNumber,
                "padding-left": "22.5px",
                unicodeBidi: "plaintext",
                "text-align": textAlignNO,
                "font-weight": "bold",
              };
            } else if (params.data.PProf < 0) {
              //mark values less than 0 red
              return {
                color: Colors.redNumber,
                unicodeBidi: "plaintext",
                "text-align": textAlignNO,
                "font-weight": "bold",
              };
            } else {
              //No mark with values equal to 0
              return { "text-align": textAlignNO };
            }
          },
          tooltipComponent: "customTooltip",
          tooltipValueGetter: function sumField(params) {
            return (
              Helpers.numberFormatterWithCommasAndDigits(params.data.PProf, 3) +
              "(" +
              Helpers.numberFormatterWithCommasAndDigits(params.data.PPerc, 3) +
              "%)"
            );
          },
          headerTooltip: this.props.t("profitloss"),
        },
        {
          headerName: this.props.t("valueLocal"),
          field: "LocBookedPsValue",
          valueFormatter: this.numberFormatter,
          hide: true,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: this.numberFormatter,
          headerTooltip: this.props.t("valueLocal"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        {
          headerName: this.props.t("marketValueLocal"),
          field: "LocNValue",
          cellRenderer: "agAnimateShowChangeCellRenderer",
          valueFormatter: this.numberFormatter,
          hide: true,
          tooltipComponent: "customTooltip",
          tooltipValueGetter: this.numberFormatter,
          headerTooltip: this.props.t("marketValueLocal"),
          cellStyle: {
            "text-align": textAlignNO,
            unicodeBidi: "plaintext",
          },
        },
        {
          headerName: this.props.t("currency"),
          field: "CurCode",
          cellRenderer: "agAnimateShowChangeCellRenderer",
          hide: false,
          tooltipComponent: "customTooltip",
          headerTooltip: this.props.t("currency"),
        },
      ],
      context: { componentParent: this },
      /* Columns characteristics */
      defaultColDef: {
        sortable: true,
        resizable: true,
        cellRenderer: "agAnimateShowChangeCellRenderer",
      },
      rowData: null,
      popupParent: document.querySelector("body"),
      isLoaderVisible: false,
      OrderIsUpdated: 0,
      IsPortfolioPopulited: false,
      IsPortfolioUpdate: false,
      isFirstTimeOpen: true,
      RefreachRequest: false,
    };
  }

  componentDidMount = () => {
    console.log("PortfolioFromDB");
    this.initialize();
  };

  componentWillUnmount = () => {
    if (this.state.profitLossData?.length > 0) {
      this.callUnSubscribe(this.state.profitLossData);
    }
  };

  // UpdatePortfolioFromBal = (MWData, PortfolioRecord) => {
  //
  //   const qty = Math.abs(PortfolioRecord.Qty);

  //   PortfolioRecord.PrClosePrice = parseFloat(MWData["LastTradePrice"]);
  //   PortfolioRecord.NValue = qty * parseFloat(MWData["LastTradePrice"]);
  //   PortfolioRecord.LocNValue = PortfolioRecord.NValue * PortfolioRecord.Rate;

  //   PortfolioRecord.PProf =
  //     qty >= 0
  //       ? PortfolioRecord.NValue - PortfolioRecord.PsValue
  //       : PortfolioRecord.PsValue - PortfolioRecord.NValue;

  //   PortfolioRecord.PPerc =
  //     PortfolioRecord.PProf === 0 || PortfolioRecord.PsValue === 0
  //       ? 0
  //       : +((PortfolioRecord.PProf / PortfolioRecord.PsValue) * 100).toFixed(
  //           10
  //         );

  //   this.gridApi.applyTransactionAsync({ update: [PortfolioRecord] });
  //   this.gridApi.flushAsyncTransactions?.();
  // };
  UpdatePortfolioFromBal = (MWData, PortfolioRecord) => {
    const qty = Math.abs(PortfolioRecord.Qty || 0);
    const last = parseFloat(MWData["LastTradePrice"] || 0);
    const rate = +PortfolioRecord.Rate || 1;
    const PsValue = +PortfolioRecord.PsValue || 0;

    const updated = {
      ...PortfolioRecord,
      PrClosePrice: last,
      NValue: qty * last,
      LocNValue: qty * last * rate,
    };

    updated.PProf =
      qty >= 0 ? updated.NValue - PsValue : PsValue - updated.NValue;
      
    updated.PPerc =
      PsValue === 0 ? 0 : +((updated.PProf / PsValue) * 100).toFixed(10);

    // this.gridApi?.applyTransactionAsync?.({ update: [updated] });

    this.gridApi?.applyTransactionAsync?.({ update: [updated] }, () => {
      this.gridApi?.refreshCells?.({
        columns: ["PrClosePrice"],
        force: true,
      });
    });
    this.gridApi?.flushAsyncTransactions?.();

    const newRows = (this.state.profitLossData || []).map((r) =>
      r.ClientID === updated.ClientID && r.Symbol === updated.Symbol
        ? updated
        : r
    );
    let totalHoldingCost = 0;
    let totalMarketValue = 0;
    let totalPL = 0;
    let totalRealizedPL = 0;
    let totalExpectedPL = 0;
    let totalExpectedSellComm = 0;
    let totalNetPortfolio = 0;

    for (const item of newRows) {
      const _PsValue = +item.PsValue || 0;
      const _NValue = +item.NValue || 0;
      const _PProf = +item.PProf || 0;
      totalHoldingCost += _PsValue;
      totalMarketValue += _NValue;
      totalPL += _PProf;
      totalRealizedPL += +item.Total_Realized_Profit_Loss || 0;
      totalExpectedPL += _PProf;
      totalExpectedSellComm += +item.Total_Expected_Sell_Comm || 0;
      totalNetPortfolio += +item.Total_Market_Value || 0;
    }

    const totalNetPL = totalRealizedPL + totalPL - totalExpectedSellComm;

    // this.gridApi?.applyTransactionAsync?.({ update: [updated] }, () => {
    //   this.gridApi?.refreshCells?.({ force: true });
    // });

    // this.gridApi?.applyTransactionAsync?.({ update: [updated] }, () => {
    //   this.gridApi?.refreshCells?.({
    //     columns: ["PrClosePrice"],
    //     force: true,
    //   });
    // });

    this.setState({
      profitLossData: newRows,
      totalHoldingCost,
      totalMarketValue,
      totalPL,
      totalRealizedPL,
      totalExpectedPL,
      totalExpectedSellComm,
      totalNetPL,
      totalNetPortfolio,
    });

    // this.props.SET_PORTFOLIO_Data(newRows, totalMarketValue);
  };

  componentDidUpdate(prevProps) {
    this.initialize();
    //console.log("componentDidUpdate isFirstTimeOpen")

    // if (
    //   (prevProps.portfolioData !== this.props.portfolioData &&
    //   this.props.portfolioData?.length > 0 &&  this.state.selectedAccount.MainClientID !== "" &&    this.state.selectedAccount.ClientID !== "")
    // )
    if (
      this.state.OrderIsUpdated !== this.props.OrderIsUpdated &&
      this.props.OrderIsUpdated !== 0 &&
      this.props.OrderIsUpdated !== 1 &&
      this.state.selectedAccount.ClientID != ""
    ) {
      
      if (this.state.selectedAccount.ClientID === "-1") {
        // setTimeout(() => {
        var allMainClientID = "";
        this.state.accounts.forEach((item) => {
          if (!allMainClientID.includes(item.MainClientID))
            allMainClientID = item.MainClientID + "," + allMainClientID;
        });
        if (allMainClientID !== "") {
          allMainClientID = allMainClientID.substring(
            0,
            allMainClientID.length - 1
          );
        }
        // console.log("allMainClientID", allMainClientID);
        this.setState(
          {
            selectedAccount: {
              ...this.state.selectedAccount,
              MainClientID: allMainClientID,
              ClientID: "-1",
              IsPortfolioPopulited: false,
              IsPortfolioUpdate: false,
            },
          },
          () => {
            // this.callsignalRPortfolio();

            // this.callGetPortfolioAndAccSum(
            //   this.state.selectedAccount.MainClientID,
            //   this.state.selectedAccount.ClientID
            // );
            this.callRefreachRequest(
              this.state.selectedAccount.MainClientID,
              this.state.selectedAccount.ClientID
            );
            this.props.setOrderIsUpdated(0, "");
          }
        );
        // }, 1000)
      } else if (
        this.state.selectedAccount.ClientID ===
          this.props.ClientIDOrderIsUpdated &&
        this.props.ClientIDOrderIsUpdated !== prevProps.ClientIDOrderIsUpdated
      ) {
        let delay = localStorage.getItem(
          Constants.localStorageConstants.PortfoliRefreshDelay
        );
        delay = delay ? Number(delay) : 1000;
        setTimeout(() => {
          this.setState(
            {
              IsPortfolioPopulited: false,
            },
            () => {
              // this.callsignalRPortfolio();

              // this.callGetPortfolioAndAccSum(
              //   this.state.selectedAccount.MainClientID,
              //   this.state.selectedAccount.ClientID
              // );

              this.callRefreachRequest(
                this.state.selectedAccount.MainClientID,
                this.state.selectedAccount.ClientID
              );

              this.props.setOrderIsUpdated(0, "");
              return;
            }
          );
        }, delay);
      }
    }

    if (
      !this.state.IsPortfolioPopulited &&
      this.props.portfolioDataFirstReq?.length > 0 &&
      this.state.selectedAccount.MainClientID !== "" &&
      this.state.selectedAccount.ClientID !== ""
    ) {
      // this.callGetPortfolioAndAccSum(
      //   this.state.selectedAccount.MainClientID,
      //   this.state.selectedAccount.ClientID
      // );

      if (
        this.props.portfolioDataFirstReq?.length > 0 &&
        this.props.portfolioDataFirstReq.every(
          (item) =>
            item.Main_clinet_id === this.state.selectedAccount.MainClientID &&
            item.ClientID === this.state.selectedAccount.ClientID
        )
      ) {
        const Portfolioes = this.props.portfolioDataFirstReq;
        let totalHoldingCost = 0;
        let totalMarketValue = 0;
        let totalPL = 0;
        let totalRealizedPL = 0;
        let totalExpectedPL = 0;
        let totalExpectedSellComm = 0;
        let totalNetPL = 0;
        let totalNetPortfolio = 0;
        
        if (this.props.SelectedAccountSummaries !== null) {
          if (
            this.state.selectedAccount.ClientID ===
            this.props.SelectedAccountSummaries.clientID
          )
            totalNetPL = this.props.SelectedAccountSummaries.NetProfitLoss;
        }
        Portfolioes.forEach((item) => {
          totalHoldingCost += item["PsValue"];
          totalMarketValue += item["NValue"];
          totalPL += item["PProf"];
          totalRealizedPL = item["Total_Realized_Profit_Loss"];
          totalExpectedPL += item["PProf"];
          totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
          totalNetPortfolio = item["Total_Market_Value"];
          //   totalNetPL += (Number(item["PProf"]) + Number(item["Profit"]));
        });
        this.props.SET_PORTFOLIO_Data(Portfolioes, totalMarketValue);
        this.setState(
          {
            profitLossData: Portfolioes,
            IsPortfolioUpdate: false,
            isFirstTimeOpen: false,
            IsPortfolioPopulited: true,
            totalHoldingCost,
            totalMarketValue,
            totalPL,
            totalRealizedPL,
            totalExpectedPL,
            totalExpectedSellComm,
            totalNetPL,
            totalNetPortfolio,
          },
          () => {
            this.callsignalR(Portfolioes);
          }
        );

        // this.props.setSelectedAccountFromPortfolioWorkspace(
        //   this.state.selectedAccount
        // );
        // return;
      }
    }

    // if (prevProps.MarketWatchDatafeed !== this.props.MarketWatchDatafeed && this.props.MarketWatchDatafeed !== "" && this.state.profitLossData !== null && this.state.profitLossData.length >= 0) {
    //     var data = JSON.parse(this.props.MarketWatchDatafeed);
    //     let portfolio = this.state.profitLossData;
    //     let CheckifSymbolExist = portfolio.filter((port) => (port.Symbol === data.Symbol))
    //     if (data !== null && CheckifSymbolExist !== null && CheckifSymbolExist.length > 0)
    //         if (parseFloat(data["LastTradePrice"]) !== parseFloat(CheckifSymbolExist[0].PrClosePrice))
    //             this.callsignalRPortfolio();
    // }

    if (
      this.props.isSubscribedSymbolsChanged !== undefined &&
      this.props.isSubscribedSymbolsChanged !== null &&
      this.props.isSubscribedSymbolsChanged !==
        prevProps.isSubscribedSymbolsChanged &&
      this.state.profitLossData?.length > 0 &&
      localStorage
        .getItem(Constants.localStorageConstants.RealTimePortfolioUpdate)
        .toUpperCase() === "TRUE"
    ) {
      this.setState({ IsPortfolioUpdate: false }, () => {
        this.callsignalR(this.state.profitLossData);
      });
    }

    if (
      this.props.PreferredAccount !== prevProps.PreferredAccount &&
      this.props.PreferredAccount &&
      this.state.accounts?.length > 0
    ) {
      const prefId = String(
        this.props.PreferredAccount.ClientID ?? this.props.PreferredAccount
      );

      if (String(this.state.selectedAccount?.ClientID) !== prefId) {
        this.onChangeAccount(prefId, false);
      }
    }
  }
  CheckMarketWAtchUpdateData = (MWDatafeed) => {
    try {
      if (
        MWDatafeed !== null &&
        MWDatafeed !== "" &&
        this.state.profitLossData !== null &&
        this.state.profitLossData.length >= 0
      ) {
        var data = JSON.parse(MWDatafeed);
        let portfolio = this.state.profitLossData;
        let CheckifSymbolExist = portfolio.filter(
          (port) => port.Symbol === data.Symbol
        );
        if (
          data !== null &&
          CheckifSymbolExist !== null &&
          CheckifSymbolExist.length > 0
        )
          if (
            parseFloat(data["LastTradePrice"]) !==
              parseFloat(CheckifSymbolExist[0].PrClosePrice) &&
            parseFloat(data["LastTradePrice"]) != 0
          ) {
            //this.UpdatePortfolioFromBal(data, CheckifSymbolExist[0]);
            if (
              localStorage
                .getItem(
                  Constants.localStorageConstants.RealTimePortfolioUpdate
                )
                .toUpperCase() === "TRUE"
            ) {
              this.UpdatePortfolioFromBal(data, CheckifSymbolExist[0]);
            } else {
              // this.callGetPortfolioAndAccSum(
              //   this.state.selectedAccount.MainClientID,
              //   this.state.selectedAccount.ClientID
              // );
            }
          }
      }
    } catch (error) {
      return;
    }
    // if (MWDatafeed !== null && MWDatafeed !== "") {
    //     var data = JSON.parse(MWDatafeed);
    //     if (data !== null && data.Symbol === this.state.selectedSymbolSearchSelect)
    //         this.getDataFromSignalr(data);
    // }
  };
  getAllRows() {
    let rowData = [];
    this.gridApi.forEachNode((node) => rowData.push(node.data));
    return rowData;
  }

  initialize = () => {
    if (
      this.props.accounts !== undefined &&
      this.props.accounts !== null &&
      this.props.accounts.length > 0 &&
      !this.state.isAccountSelectedFromProps
    ) {
      this.setState(
        {
          accounts: this.props.accounts,
          isAccountSelectedFromProps: true,
        },
        () => {
          // var allMainClientID = ""
          if (this.props.PreferredAccount) {
            const prefId = String(
              this.props.PreferredAccount.ClientID ??
                this.props.PreferredAccount
            );

            if (String(this.state.selectedAccount?.ClientID) !== prefId) {
              this.onChangeAccount(prefId, false);
              return;
            }
          }

          var count = 0;
          this.state.accounts.forEach((item, index) => {
            if (item.IS_DEFAULT_ACC === "Y") {
              count += 1;
              this.setState(
                {
                  IsPortfolioPopulited: false,
                  selectedAccount: item,
                },
                () => {
                  this.props.setSelectedAccountFromPortfolioWorkspace(item);
                  //   this.onChangeAccount(item.ClientID, false);
                  return;
                }
              );
            } else if (
              index === this.state.accounts.length - 1 &&
              count === 0
            ) {
              this.setState(
                {
                  IsPortfolioPopulited: false,
                  selectedAccount: this.state.accounts[0],
                },
                () => {
                  // this.onChangeAccount(this.state.accounts[0].ClientID, false);
                }
              );
            }

            // if (index === 0) {
            //     if (!allMainClientID.includes(item.MainClientID))
            //         allMainClientID = item.MainClientID + "," + allMainClientID
            //         //

            //     this.setState({
            //         selectedAccount: {
            //             ...this.state.selectedAccount,
            //             MainClientID: allMainClientID,
            //             ClientID: "-1"
            //         }
            //     }, () => {
            //         this.callGetExpectedProfitLoss();
            //         this.props.setSelectedAccountFromPortfolioWorkspace(this.state.selectedAccount);
            //     });

            //     // this.setState({ selectedAccount: item }, () => {
            //     //     this.callGetExpectedProfitLoss();
            //     // });
            //     return;
            // }
          });
        }
      );
    }

    if (this.state.isGridReady && this.state.profitLossData !== null) {
      this.gridApi.setRowData(this.state.profitLossData);
      this.autoSizeAll(false);
    }
  };

  callsignalRPortfolio = () => {
    if (
      localStorage.getItem("user") === null ||
      localStorage.getItem("user") === undefined
    ) {
      return;
    }
    if (!Helpers.isJsonString(localStorage.getItem("user"))) {
      return;
    }

    if (
      this.props.signalr_connection !== undefined &&
      this.props.signalr_connection !== null &&
      this.props.signalr_connection.state === 1 &&
      this.state.selectedAccount.ClientID != "" &&
      !this.state.IsPortfolioPopulited
    ) {
      let user = JSON.parse(localStorage.getItem("user"));
      let brokerId = user.BrokerID;
      this.props.signalr_connection.proxies.myhub.invoke(
        "GetPortfolio",
        this.state.selectedAccount.MainClientID,
        this.state.selectedAccount.ClientID,
        localStorage.getItem("WebCode"),
        Helpers.dateToString(new Date(), true),
        brokerId,
        "S"
      );
      this.props.signalr_connection.proxies.myhub.on(
        "GetPortfolio",
        (MW_UPDATE) => this.getdatafromSignalr(MW_UPDATE)
      );
      this.setState({
        IsPortfolioPopulited: true,
        isFirstTimeOpen: false,
      });
    }
  };

  getdatafromSignalr = (portfolioData) => {
    this.setIsLoaderVisible(false);
    var data = JSON.parse(portfolioData);

    let checkQty = [];
    if (data.length > 0 && data !== null) {
      checkQty = data.filter((port) => Number(port.Qty) !== 0);
    }
    data = checkQty;
    if (this.state.RefreachRequest) {
      setTimeout(() => {
        this.setState({
          RefreachRequest: false,
        });
      }, 10000);
    }

    this.setState({ profitLossData: data });

    if (this.state.accounts.length === 1) {
      this.props.setFirstTimePortfolioCall(data);
    } else {
      if (this.state.selectedAccount.IS_DEFAULT_ACC === "Y") {
        this.props.setFirstTimePortfolioCall(data);
      }
    }
    //  console.log("getdatafromSignalr portfolio", data);
    let totalHoldingCost = 0;
    let totalMarketValue = 0;
    let totalPL = 0;
    let totalRealizedPL = 0;
    let totalExpectedPL = 0;
    let totalExpectedSellComm = 0;
    let totalNetPL = 0;
    let totalNetPortfolio = 0;
    if (data.length > 0 && data !== null) {
      data.forEach((item) => {
        totalHoldingCost += item["PsValue"];
        totalMarketValue += item["NValue"];
        totalPL += item["PProf"];
        totalRealizedPL += item["Profit"];
        totalExpectedPL += item["PProf"];
        totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
        //   totalNetPL += (Number(item["PProf"]) + Number(item["Profit"]));
        totalNetPortfolio += Number(item["NValue"]) + Number(item["Profit"]); // market Value + Remaining balance(acc summary)
      });
      this.callsignalR(data);
    }
    this.props.SET_PORTFOLIO_Data(data, totalMarketValue);
    this.setState({
      totalHoldingCost,
      totalMarketValue,
      totalPL,
      totalRealizedPL,
      totalExpectedPL,
      totalExpectedSellComm,
      totalNetPL,
      totalNetPortfolio,
    });
  };
  getdatafromSignalrfirstTime = (portfolioData) => {
    this.setIsLoaderVisible(false);
    let checkQty = [];
    if (portfolioData.length > 0 && portfolioData !== null) {
      checkQty = portfolioData.filter((port) => Number(port.Qty) !== 0);
    }
    var data = checkQty;

    this.setState({
      profitLossData: data,
      isFirstTimeOpen: false,
      IsPortfolioPopulited: true,
    });

    console.log("getdatafromSignalr portfolio", data);
    let totalHoldingCost = 0;
    let totalMarketValue = 0;
    let totalPL = 0;
    let totalRealizedPL = 0;
    let totalExpectedPL = 0;
    let totalExpectedSellComm = 0;
    let totalNetPL = 0;
    let totalNetPortfolio = 0;
    if (data.length > 0 && data !== null) {
      data.forEach((item) => {
        totalHoldingCost += item["PsValue"];
        totalMarketValue += item["NValue"];
        totalPL += item["PProf"];
        totalRealizedPL += item["Profit"];
        totalExpectedPL += item["PProf"];
        totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
        //    totalNetPL += (Number(item["PProf"]) + Number(item["Profit"]));
        totalNetPortfolio += Number(item["NValue"]) + Number(item["Profit"]); // market Value + Remaining balance(acc summary)
      });
      this.callsignalR(data);
    }
    this.props.SET_PORTFOLIO_Data(data, totalMarketValue);
    this.setState({
      totalHoldingCost,
      totalMarketValue,
      totalPL,
      totalRealizedPL,
      totalExpectedPL,
      totalExpectedSellComm,
      totalNetPL,
      totalNetPortfolio,
    });
  };

  // async callGetExpectedProfitLoss(MainClientID, ClientID) {

  //     if (localStorage.getItem("user") === null || localStorage.getItem("user") === undefined) {
  //         return;
  //     }
  //     if (!Helpers.isJsonString(localStorage.getItem("user"))) {
  //         return
  //     }
  //     if (this.state.IsPortfolioPopulited) {
  //         return
  //     }
  //     this.setIsLoaderVisible(true);
  //     let user = JSON.parse(localStorage.getItem("user"));
  //     let brokerId = user.BrokerID;
  //     let url = Constants.getExpectedProfitLoss;
  //     url += MainClientID;
  //     url += '/';
  //     url += ClientID;
  //     url += '/';
  //     url += localStorage.getItem("WebCode");
  //     url += '/';
  //     url += Helpers.dateToString(new Date(), true);
  //     url += '/';
  //     url += brokerId;
  //     url += '?';
  //     url += Math.random();

  //     // let getExpectedProfitLossResponse = await utils.getExpectedProfitLoss(url);
  //     // getExpectedProfitLossResponse
  //     //  .then( response =>  response.data)
  //     // .then(data => {
  //     try {
  //         let response = await utils.getExpectedProfitLoss(url);
  //         let data = await response.data;
  //         console.log("response.data Portfolio", data)
  //         this.setIsLoaderVisible(false);

  //         let checkQty = [];
  //         if (data.length > 0 && data !== null) {
  //             checkQty = data.filter((port) => (Number(port.Qty) !== 0))
  //         }
  //         data = checkQty
  //         // if (this.state.RefreachRequest) {
  //         //     setTimeout(() => {
  //         //         this.setState({
  //         //             RefreachRequest: false
  //         //         })
  //         //     }, 10000);
  //         // }

  //         this.setState({ profitLossData: data, isFirstTimeOpen: false, IsPortfolioPopulited: true });
  //         let totalHoldingCost = 0;
  //         let totalMarketValue = 0;
  //         let totalPL = 0;
  //         let totalRealizedPL = 0;
  //         let totalExpectedPL = 0;
  //         let totalExpectedSellComm = 0;
  //         let totalNetPL = 0;
  //         let totalNetPortfolio = 0;
  //         if (data.length > 0) {
  //             data.forEach((item) => {
  //                 totalHoldingCost += item["PsValue"];
  //                 totalMarketValue += item["NValue"];
  //                 totalPL += item["PProf"];
  //                 totalRealizedPL = item["Total_Realized_Profit_Loss"];
  //                 totalExpectedPL += item["PProf"];
  //                 totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
  //                 totalNetPL += (Number(item["PProf"]) + Number(item["Profit"]));
  //                 totalNetPortfolio = item["Total_Market_Value"];
  //             })
  //         }
  //         this.props.SET_PORTFOLIO_Data(data, totalMarketValue);
  //         this.setState({
  //             totalHoldingCost,
  //             totalMarketValue,
  //             totalPL,
  //             totalRealizedPL,
  //             totalExpectedPL,
  //             totalExpectedSellComm,
  //             totalNetPL,
  //             totalNetPortfolio,

  //         })
  //         this.props.setSelectedAccountFromPortfolioWorkspace(this.state.selectedAccount);
  //     }

  //     /// })
  //     catch (error) {
  //         console.log("callGetExpectedProfitLoss error", error);
  //         this.setIsLoaderVisible(false);
  //         this.setState({ profitLossData: [], isFirstTimeOpen: false, IsPortfolioPopulited: true });
  //         this.props.setSelectedAccountFromPortfolioWorkspace(this.state.selectedAccount);

  //     };

  // }
  async callGetPortfolioAndAccSum(MainClientID, ClientID) {
    if (
      this.props.portfolioDataFirstReq?.length > 0 &&
      this.props.portfolioDataFirstReq.every(
        (item) =>
          item.Main_clinet_id === MainClientID && item.ClientID === ClientID
      ) &&
      this.props.OrderIsUpdated !== 3
    ) {
      
      const Portfolioes = this.props.portfolioDataFirstReq;
      let totalHoldingCost = 0;
      let totalMarketValue = 0;
      let totalPL = 0;
      let totalRealizedPL = 0;
      let totalExpectedPL = 0;
      let totalExpectedSellComm = 0;
      let totalNetPL = 0;
      let totalNetPortfolio = 0;

      if (this.props.SelectedAccountSummaries !== null) {
        if (
          this.state.selectedAccount.ClientID ===
          this.props.SelectedAccountSummaries.clientID
        )
          totalNetPL = this.props.SelectedAccountSummaries.NetProfitLoss;
      }
      Portfolioes.forEach((item) => {
        totalHoldingCost += item["PsValue"];
        totalMarketValue += item["NValue"];
        totalPL += item["PProf"];
        totalRealizedPL = item["Total_Realized_Profit_Loss"];
        totalExpectedPL += item["PProf"];
        totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
        totalNetPortfolio = item["Total_Market_Value"];
      });
      this.props.SET_PORTFOLIO_Data(Portfolioes, totalMarketValue);

      if (this.state.accounts.length === 1) {
        // if(this.state.accounts[0].ClientID === PortfolioesClientID)
        this.props.setFirstTimePortfolioCall(Portfolioes);
      } else {
        if (this.state.selectedAccount.IS_DEFAULT_ACC === "Y") {
          this.props.setFirstTimePortfolioCall(Portfolioes);
        }
      }
      this.setState(
        {
          profitLossData: Portfolioes,
          isFirstTimeOpen: false,
          IsPortfolioPopulited: true,
          totalHoldingCost,
          totalMarketValue,
          totalPL,
          totalRealizedPL,
          totalExpectedPL,
          totalExpectedSellComm,
          totalNetPL,
          totalNetPortfolio,
        },
        () => this.callsignalR(Portfolioes)
      );

      this.props.setSelectedAccountFromPortfolioWorkspace(
        this.state.selectedAccount
      );
      return;
    }

    if (
      localStorage.getItem("user") === null ||
      localStorage.getItem("user") === undefined
    ) {
      return;
    }
    if (!Helpers.isJsonString(localStorage.getItem("user"))) {
      return;
    }

    if (this.state.IsPortfolioPopulited) {
      return;
    }
    this.setIsLoaderVisible(true);
    let user = JSON.parse(localStorage.getItem("user"));
    if (user === null) {
      return;
    }
    let brokerId = user.BrokerID;
    let userCode = user.UCode;

    let url = Constants.GetPortfolioAndAccSum;
    url += MainClientID;
    url += "/";
    url += ClientID;
    url += "/";
    url += localStorage.getItem("WebCode");
    url += "/";
    url += Helpers.dateToString(new Date(), true);
    url += "/";
    url += brokerId;
    url += "/";
    url += userCode;
    url += "?";
    url += Math.random();

    // let getExpectedProfitLossResponse = await utils.getExpectedProfitLoss(url);
    // getExpectedProfitLossResponse
    //  .then( response =>  response.data)
    // .then(data => {
    try {
      let response = await utils.getPortfolioAndAccSum(url);
      let data = await response.data;

      this.setIsLoaderVisible(false);

      let checkQty = [];
      var Portfolioes = data.Portfolioes;
      var AccountSummaries = data.AccountSummaries;

      if (Portfolioes.length > 0 && Portfolioes !== null) {
        checkQty = Portfolioes.filter((port) => Number(port.Qty) !== 0);
      }
      Portfolioes = checkQty;

      this.setState({
        profitLossData: Portfolioes,
        isFirstTimeOpen: false,
        IsPortfolioPopulited: true,
      });
      let totalHoldingCost = 0;
      let totalMarketValue = 0;
      let totalPL = 0;
      let totalRealizedPL = 0;
      let totalExpectedPL = 0;
      let totalExpectedSellComm = 0;
      let totalNetPL = 0;
      let totalNetPortfolio = 0;
      if (AccountSummaries !== null) {
        totalNetPL = AccountSummaries.NetProfitLoss;
      }
      if (Portfolioes.length > 0) {
        Portfolioes.forEach((item) => {
          totalHoldingCost += item["PsValue"];
          totalMarketValue += item["NValue"];
          totalPL += item["PProf"];
          totalRealizedPL = item["Total_Realized_Profit_Loss"];
          totalExpectedPL += item["PProf"];
          totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
          // totalNetPL += (Number(item["PProf"]) + Number(item["Profit"]));
          totalNetPortfolio = item["Total_Market_Value"];
        });
        this.callsignalR(Portfolioes);
      }
      this.props.SET_PORTFOLIO_Data(Portfolioes, totalMarketValue);
      this.setState({
        totalHoldingCost,
        totalMarketValue,
        totalPL,
        totalRealizedPL,
        totalExpectedPL,
        totalExpectedSellComm,
        totalNetPL,
        totalNetPortfolio,
      });
      this.props.setSelectedAccountFromPortfolioWorkspace(
        this.state.selectedAccount
      );

      if (this.state.accounts.length === 1) {
        // if(this.state.accounts[0].ClientID === PortfolioesClientID)
        this.props.setFirstTimePortfolioCall(Portfolioes);
      } else {
        if (this.state.selectedAccount.IS_DEFAULT_ACC === "Y") {
          this.props.setFirstTimePortfolioCall(Portfolioes);
        }
      }
      //this.props.setSelectedAccountSummaries(data.AccountSummaries);
    } catch (error) {
      /// })
      console.log("callGetPortfolioAndAccSum error", error);
      this.setIsLoaderVisible(false);
      this.setState({
        profitLossData: [],
        isFirstTimeOpen: false,
        IsPortfolioPopulited: true,
      });
      this.props.setSelectedAccountFromPortfolioWorkspace(
        this.state.selectedAccount
      );
    }
  }
  async callRefreachRequest(MainClientID, ClientID) {
    if (
      localStorage.getItem("user") === null ||
      localStorage.getItem("user") === undefined
    ) {
      return;
    }
    if (!Helpers.isJsonString(localStorage.getItem("user"))) {
      return;
    }
    if (this.state.IsPortfolioPopulited) {
      return;
    }
    this.setIsLoaderVisible(true);
    let user = JSON.parse(localStorage.getItem("user"));
    if (user === null) {
      return;
    }
    let brokerId = user.BrokerID;
    let userCode = user.UCode;
    if (this.state.RefreachRequest) {
      setTimeout(() => {
        this.setState({
          RefreachRequest: false,
        });
      }, 5000);
    }
    let url = Constants.GetPortfolioAndAccSum;
    url += MainClientID;
    url += "/";
    url += ClientID;
    url += "/";
    url += localStorage.getItem("WebCode");
    url += "/";
    url += Helpers.dateToString(new Date(), true);
    url += "/";
    url += brokerId;
    url += "/";
    url += userCode;
    url += "?";
    url += Math.random();

    // let getExpectedProfitLossResponse = await utils.getExpectedProfitLoss(url);
    // getExpectedProfitLossResponse
    //  .then( response =>  response.data)
    // .then(data => {
    try {
      let response = await utils.getPortfolioAndAccSum(url);
      let data = await response.data;

      this.setIsLoaderVisible(false);

      let checkQty = [];
      var Portfolioes = data.Portfolioes;
      var AccountSummaries = data.AccountSummaries;

      if (Portfolioes.length > 0 && Portfolioes !== null) {
        checkQty = Portfolioes.filter((port) => Number(port.Qty) !== 0);
      }
      Portfolioes = checkQty;
      // if (this.state.RefreachRequest) {
      //     setTimeout(() => {
      //         this.setState({
      //             RefreachRequest: false
      //         })
      //     }, 10000);
      // }

      this.setState({
        profitLossData: Portfolioes,
        isFirstTimeOpen: false,
        IsPortfolioPopulited: true,
      });
      let totalHoldingCost = 0;
      let totalMarketValue = 0;
      let totalPL = 0;
      let totalRealizedPL = 0;
      let totalExpectedPL = 0;
      let totalExpectedSellComm = 0;
      let totalNetPL = 0;
      let totalNetPortfolio = 0;
      if (AccountSummaries !== null) {
        totalNetPL = AccountSummaries.NetProfitLoss;
      }
      if (Portfolioes.length > 0) {
        Portfolioes.forEach((item) => {
          totalHoldingCost += item["PsValue"];
          totalMarketValue += item["NValue"];
          totalPL += item["PProf"];
          totalRealizedPL = item["Total_Realized_Profit_Loss"];
          totalExpectedPL += item["PProf"];
          totalExpectedSellComm = item["Total_Expected_Sell_Comm"];
          // totalNetPL += (Number(item["PProf"]) + Number(item["Profit"]));
          totalNetPortfolio = item["Total_Market_Value"];
        });
      }
      this.props.SET_PORTFOLIO_Data(Portfolioes, totalMarketValue);

      if (this.state.accounts.length === 1) {
        // if(this.state.accounts[0].ClientID === PortfolioesClientID)
        this.props.setFirstTimePortfolioCall(Portfolioes);
      } else {
        if (this.state.selectedAccount.IS_DEFAULT_ACC === "Y") {
          this.props.setFirstTimePortfolioCall(Portfolioes);
        }
      }
      this.setState(
        {
          IsPortfolioUpdate: false,
          totalHoldingCost,
          totalMarketValue,
          totalPL,
          totalRealizedPL,
          totalExpectedPL,
          totalExpectedSellComm,
          totalNetPL,
          totalNetPortfolio,
        },
        () => this.callsignalR(Portfolioes)
      );
      this.props.setSelectedAccountFromPortfolioWorkspace(
        this.state.selectedAccount
      );

      this.props.setSelectedAccountSummaries(data.AccountSummaries);
    } catch (error) {
      /// })
      console.log("callGetPortfolioAndAccSum error", error);
      this.setIsLoaderVisible(false);
      this.setState({
        profitLossData: [],
        isFirstTimeOpen: false,
        IsPortfolioPopulited: true,
      });
      this.props.setSelectedAccountFromPortfolioWorkspace(
        this.state.selectedAccount
      );
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
    this.setState({ isGridReady: true });
  };
  //resize grid columns to fit content
  autoSizeAll = (skipHeader) => {
    if (this.state.isGridReady) {
      var allColumnIds = [];
      this.gridColumnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }
  };

  /* Number formatter ###,###,###*/
  numberFormatter(params) {
    return Helpers.numberFormatterWithCommasAndDigits(params.value, 3);
  }

  onChangeAccount = (event, isChange) => {
    let paramAccountId = isChange ? event.target.value : event;
    var allMainClientID = "";

    if (this.state.selectedAccount.ClientID !== paramAccountId) {
      this.setState(
        {
          profitLossData: [],
          totalHoldingCost: 0,
          totalMarketValue: 0,
          totalPL: 0,
          totalRealizedPL: 0,
          totalExpectedPL: 0,
          totalExpectedSellComm: 0,
          totalNetPL: 0,
          totalNetPortfolio: 0,
        },
        () => {
          this.props.SET_PORTFOLIO_Data([], 0);
          if (this.state.isGridReady) {
            this.gridApi.setRowData([]);
            this.autoSizeAll(false);
          }
        }
      );
    }
    if (paramAccountId === "-1") {
      this.state.accounts.forEach((item) => {
        if (!allMainClientID.includes(item.MainClientID))
          allMainClientID = item.MainClientID + "," + allMainClientID;
      });

      // if (allMainClientID !== "") {
      //     allMainClientID = allMainClientID.substring(0, allMainClientID.length - 1);
      // }
      console.log("allMainClientID", allMainClientID);
      this.setState(
        {
          selectedAccount: {
            ...this.state.selectedAccount,
            MainClientID: allMainClientID,
            ClientID: "-1",
            IsPortfolioPopulited: false,
            IsPortfolioUpdate: false,
          },
        },
        () => {
          // this.callsignalRPortfolio();

          this.callGetPortfolioAndAccSum(
            this.state.selectedAccount.MainClientID,
            this.state.selectedAccount.ClientID
          );
          // if (this.state.isFirstTimeOpen) {
          //     this.callGetExpectedProfitLoss(item.MainClientID, item.ClientID)
          // }
          // //       this.props.setSelectedAccountFromPortfolioWorkspace(this.state.selectedAccount);
        }
      );

      // this.props.setSelectedAccountFromPortfolioWorkspace(this.state.selectedAccount);
    } else {
      //

      let AccountFilter = this.state.accounts.filter(
        (accs) => accs.ClientID === paramAccountId
      )[0];
      if (AccountFilter != undefined && AccountFilter !== null) {
        this.setState(
          {
            selectedAccount: AccountFilter,
            IsPortfolioPopulited: false,
            IsPortfolioUpdate: false,
          },
          () => {
            this.callGetPortfolioAndAccSum(
              AccountFilter.MainClientID,
              AccountFilter.ClientID
            );
          }
        );
      }
    }
    // this.state.accounts.forEach(item => {
    //     if (item.AccountID === paramAccountId) {

    //     }
    // });
  };

  // onCellDoubleClicked = (params) => {
  //     //if (params.colDef.field === "Symbol") {
  //     this.props.orderFromPortfolio(params.data.Symbol, params.data.Quantity)
  //     this.isBidOrOffer = true;
  //     //}
  // }
  callsignalR = (data) => {
    if (
      this.props.signalr_connection !== undefined &&
      this.props.signalr_connection !== null &&
      this.props.signalr_connection.state === 1 &&
      !this.state.IsPortfolioUpdate &&
      data?.length > 0 &&
      localStorage
        .getItem(Constants.localStorageConstants.RealTimePortfolioUpdate)
        .toUpperCase() === "TRUE"
    ) {
      data.map((sym) => {
        this.props.signalr_connection.proxies.myhub.invoke(
          "AddMarketWatchProfileSymbol",
          localStorage.getItem("username"),
          sym.Symbol
        );

        this.props.setSymbolToSub(this.props.screenid, sym.Symbol);
      });
      this.setState({
        IsPortfolioUpdate: true,
      });
    }
  };

  callsignalRNew = (data) => {
    const conn = this.props.signalr_connection;
    const canRT =
      (
        localStorage.getItem(
          Constants.localStorageConstants.RealTimePortfolioUpdate
        ) || ""
      ).toUpperCase() === "TRUE";

    if (
      !conn ||
      conn.state !== 1 ||
      this.state.IsPortfolioUpdate ||
      !Array.isArray(data) ||
      data.length === 0 ||
      !canRT
    ) {
      return;
    }

    const screenId = this.props.screenid;
    const list = this.props.SymbolToBesubscribed || [];

    const isSameScreen = (it) =>
      it.ScreenID === screenId || it.ScreenID?.includes?.(screenId);

    const existing = new Set(list.filter(isSameScreen).map((it) => it.Symbol));

    data.forEach((sym) => {
      const symbol = sym?.Symbol;
      if (!symbol) return;

      if (existing.has(symbol)) return;

      conn.proxies.myhub.invoke(
        "AddMarketWatchProfileSymbol",
        localStorage.getItem("username"),
        symbol
      );

      this.props.setSymbolToSub(screenId, symbol);
      existing.add(symbol);
    });

    this.setState({ IsPortfolioUpdate: true });
  };

  callUnSubscribe = (data) => {
    // if (
    //   this.props.signalr_connection !== undefined &&
    //   this.props.signalr_connection !== null &&
    //   this.props.signalr_connection.state === 1 &&
    //   data?.length > 0
    // ) {
    //   data.map((sym) => {
    //     this.props.signalr_connection.proxies.myhub.invoke(
    //       "DeleteMarketWatchProfileSymbol",
    //       localStorage.getItem("username"),
    //       sym.Symbol
    //     );
    //   });
    //   this.props.setSymbolToSub(this.props.screenid, null);
    // }
    //this.props.setSymbolToSub(this.props.screenid, null);
  };
  onRowClicked = (params) => {
    //console.log("params click", params);
    //console.log("params click2", params.node.data.Symbol);
    this.props.SET_SELECT_SYMBOL_FROM_PORTFOLIO(
      params.data.Symbol,
      params.data.Comp_ID
    );
  };
  setIsLoaderVisible = (isLoaderVisible) => {
    if (this.state.isLoaderVisible !== isLoaderVisible)
      this.setState({ isLoaderVisible: isLoaderVisible });
  };
  onColumnVisible(e, c) {
    if (!e.visible) {
      e.column.gridOptionsWrapper.columnController.setColumnVisible(
        e.column.colId,
        true
      );
    }
  }
  getContextMenuItems = (params) => {
    var PDF = {
      name: this.props.t("PrintPDF"),
      action: () => {
        this.generatePPFReport();
      },
    };

    var result = [
      localStorage
        .getItem(Constants.localStorageConstants.Region)
        .toUpperCase() === "EGYPT"
        ? {
            name: this.props.t("BracketOrder"),
            action: () => {
              if (params.node !== null) {
                orderFromPortfolio.value = true;
                this.props.SMART_ORDER_OBJECT(null);
                this.BracketOrdersPopup(params.node.data);
                // this.props.changeSymbol(params.node.data.Symbol, 'B', "0", "0", "0", "0", true)
                // this.props.SYBMOL_QTY_TO_SELL(params.node.data.Symbol, "0", params.node.data.ClientID, params.node.data.Exchange, CustodianId)
              } else
                Helpers.errorNotify(
                  this.props.t("nothing_to_show"),
                  this.props.i18n.language
                );
            },
          }
        : null,
      localStorage
        .getItem(Constants.localStorageConstants.Region)
        .toUpperCase() === "EGYPT"
        ? {
            name: this.props.t("buy"),
            action: () => {
              if (params.node !== null) {
                if (
                  localStorage
                    .getItem(Constants.localStorageConstants.Region)
                    .toUpperCase() === "EGYPT"
                ) {
                  orderFromPortfolio.value = true;
                }
                var CustodianId =
                  localStorage
                    .getItem(Constants.localStorageConstants.Region)
                    .toUpperCase() === "EGYPT"
                    ? params.node.data.CustodianId
                    : "";
                this.props.SMART_ORDER_OBJECT(null);
                this.props.changeSymbol(
                  params.node.data.Symbol,
                  "B",
                  "0",
                  "0",
                  "0",
                  "0",
                  true
                );
                this.props.SYBMOL_QTY_TO_SELL(
                  params.node.data.Symbol,
                  "0",
                  params.node.data.ClientID,
                  params.node.data.Exchange,
                  CustodianId
                );
              } else
                Helpers.errorNotify(
                  this.props.t("nothing_to_show"),
                  this.props.i18n.language
                );
            },
          }
        : null,
      {
        name: this.props.t("sell"),
        action: () => {
          if (params.node !== null) {
            this.props.SMART_ORDER_OBJECT(null);
            if (
              localStorage
                .getItem(Constants.localStorageConstants.Region)
                .toUpperCase() === "EGYPT"
            ) {
              orderFromPortfolio.value = true;
            }
            var finalQty =
              localStorage
                .getItem(Constants.localStorageConstants.Region)
                .toUpperCase() === "EGYPT"
                ? 0
                : params.node.data.Qty;
            var CustodianId =
              localStorage
                .getItem(Constants.localStorageConstants.Region)
                .toUpperCase() === "EGYPT"
                ? params.node.data.CustodianId
                : "";
            this.props.changeSymbol(
              params.node.data.Symbol,
              "S",
              "0",
              "0",
              "0",
              "0",
              true
            );
            this.props.SYBMOL_QTY_TO_SELL(
              params.node.data.Symbol,
              finalQty,
              params.node.data.ClientID,
              params.node.data.Exchange,
              CustodianId
            );
          } else
            Helpers.errorNotify(
              this.props.t("nothing_to_show"),
              this.props.i18n.language
            );
        },
      },
      "export",
      PDF,
    ];

    return result;
  };

  BracketOrdersPopup = (OrderDetailsData) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className={
              "custom-popup custom-scrollable  " +
              Helpers.getAppTheme() +
              localStorage.getItem(
                Constants.localStorageConstants.company_name
              ) +
              "-CSS"
            }
            style={{ height: "270px", width: "485px" }}
          >
            <div
              className="custom-popup-header pt-2"
              style={{
                display: "flex",
                flexDirection:
                  this.props.i18n.language === "ar" ? "row-reverse" : "unset",
              }}
            >
              <div
                className={
                  this.ml3LocalizedPopupHeader +
                  " " +
                  this.mrAutoLocalized +
                  " PopupHeaderTitle"
                }
                style={{ fontSize: "14px" }}
              >
                <strong className="lableCustomized">
                  {" "}
                  {this.props.t("BracketOrder")}
                </strong>
              </div>
              <div
                className={
                  this.mr3LocalizedPopupHeader + " " + this.mlAutoLocalized
                }
              >
                <span
                  className="my-panel-extra-btn"
                  style={{
                    marginLeft: "unset",
                    float: "right",
                    transition: "none",
                    color: "white",
                    opacity: "1",
                    contain: "content",
                    width: "unset",
                    marginRight: "unset",
                  }}
                  onClick={onClose}
                >
                  X
                </span>
              </div>
            </div>
            <div
              className="custom-popup-body pt-2 pb-2 display-vertically"
              style={{
                height: "calc(100% - 45px)",
                overflowY: "auto",
                direction: this.dir,
                width: "100%",
              }}
            >
              <BracketOrdersPopup
                OrderDetailsData={OrderDetailsData}
                isDarkMode={this.props.isDarkMode}
                symbols={this.props.symbols}
                selectedAccount={this.state.selectedAccount}
                signalr_connection={this.props.signalr_connection}
                onClose={onClose}
              />
            </div>
          </div>
        );
      },
    });
  };

  // generatePPFReport = () => {
  //     PDFGenerator.GeneratePDF(this, "PORTFOLIO", this.props.i18n.language)
  // }
  generatePPFReport = () => {
    if (
      this.state.profitLossData !== null &&
      this.state.profitLossData.length > 0
    ) {
      if (
        this.state.selectedAccount !== null &&
        this.state.selectedAccount.ClientID !== undefined &&
        this.state.selectedAccount.ClientID !== ""
      ) {
        PDFGenerator.GeneratePDF(this, "PORTFOLIO", this.props.i18n.language);
      } else {
        if (
          this.state.accounts.length > 0 &&
          this.state.accounts.length === 1
        ) {
          let AccountFilter = this.state.accounts[0];
          this.setState(
            {
              selectedAccount: AccountFilter,
            },
            () => {
              PDFGenerator.GeneratePDF(
                this,
                "PORTFOLIO",
                this.props.i18n.language
              );
            }
          );
        } else {
          this.state.accounts.forEach((item, index) => {
            //
            if (item.IS_DEFAULT_ACC === "Y") {
              let AccountFilter = this.state.accounts.filter(
                (accs) => accs.ClientID === item.ClientID
              )[0];
              this.setState(
                {
                  selectedAccount: AccountFilter,
                },
                () => {
                  PDFGenerator.GeneratePDF(
                    this,
                    "PORTFOLIO",
                    this.props.i18n.language
                  );
                }
              );
            }
          });
        }
      }
    } else {
      Helpers.errorNotify(
        this.props.t("ag-overlay-noRow-center"),
        this.props.i18n.language
      );
    }
  };
  // successNotify = (message) => {
  //     toast.success(message, {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         hideProgressBar: true,
  //         autoClose: Constants.successNotifyDuration
  //     });
  // };
  render() {
    /* Section total values */
    let totalHoldingCost = this.state.totalHoldingCost;
    let totalMarketValue = this.state.totalMarketValue;
    let totalPL = this.state.totalPL;
    let totalRealizedPL = this.state.totalRealizedPL;
    let totalExpectedPL = this.state.totalExpectedPL;
    let totalExpectedPLperc = 0;
    let totalExpectedSellComm = this.state.totalExpectedSellComm;
    let totalNetPL = this.state.totalNetPL;
    let totalNetPortfolio = this.state.totalNetPortfolio;
    let ColorsgreenNumber = this.props.isDarkMode
      ? Colors.greenNumberDarkTheme
      : Colors.greenNumber;

    if (totalExpectedPL !== 0 && totalHoldingCost !== 0) {
      totalExpectedPLperc = (
        (totalExpectedPL / totalHoldingCost) *
        100
      ).toFixed(3);
    }

    /* Section Colors */
    let totalHoldingCostColor = "";
    let totalMarketValueColor = "";
    let totalPLColor = "";
    let totalRealizedPLColor = "";
    let totalExpectedPLColor = "";
    let totalExpectedPLpercColor = "";
    let totalExpectedSellCommColor = "";
    let totalNetPLColor = "";
    let totalNetPortfolioColor = "";
    /* Checking numbers less than zero before formatting to string with commas... */
    if (totalHoldingCost < 0) {
      totalHoldingCostColor = Colors.redNumber;
    }
    if (totalMarketValue < 0) {
      totalMarketValueColor = Colors.redNumber;
    }
    if (totalPL < 0) {
      totalPLColor = Colors.redNumber;
    } else {
      totalPLColor = ColorsgreenNumber;
    }
    if (totalRealizedPL < 0) {
      totalRealizedPLColor = Colors.redNumber;
    } else {
      totalRealizedPLColor = ColorsgreenNumber;
    }
    if (totalExpectedPL < 0) {
      totalExpectedPLColor = Colors.redNumber;
    } else {
      totalExpectedPLColor = ColorsgreenNumber;
    }
    if (totalExpectedPLperc < 0) {
      totalExpectedPLpercColor = Colors.redNumber;
    } else {
      totalExpectedPLpercColor = ColorsgreenNumber;
    }

    if (totalExpectedSellComm < 0) {
      totalExpectedSellCommColor = Colors.redNumber;
    }
    if (totalNetPL < 0) {
      totalNetPLColor = Colors.redNumber;
    }

    if (totalNetPortfolio < 0) {
      totalNetPortfolioColor = Colors.redNumber;
    }

    totalHoldingCost = Helpers.numberFormatterWithCommasAndDigits(
      totalHoldingCost,
      3
    );
    totalMarketValue = Helpers.numberFormatterWithCommasAndDigits(
      totalMarketValue,
      3
    );
    totalPL = Helpers.numberFormatterWithCommasAndDigits(totalPL, 3);
    totalRealizedPL = Helpers.numberFormatterWithCommasAndDigits(
      totalRealizedPL,
      3
    );
    totalExpectedPL = Helpers.numberFormatterWithCommasAndDigits(
      totalExpectedPL,
      3
    );
    totalExpectedSellComm = Helpers.numberFormatterWithCommasAndDigits(
      totalExpectedSellComm,
      3
    );
    totalNetPL = Helpers.numberFormatterWithCommasAndDigits(totalNetPL, 3);
    totalNetPortfolio = Helpers.numberFormatterWithCommasAndDigits(
      totalNetPortfolio,
      3
    );

    let agGridClass = "ag-theme-alpine";
    if (this.props.isDarkMode) {
      agGridClass = "ag-theme-alpine-dark";
    } else {
      if (localStorage.getItem("theme") == "dark") {
        agGridClass = "ag-theme-alpine-dark";
      }
    }

    let i18n = this.props.i18n;

    let leftLocalized = "left";
    let rightLocalized = "right";
    let ml3Localized = "ml-3";
    let mr3Localized = "mr-3";
    let mr2Localized = "mr-2";
    let spanClass = "ml-1 bolded";
    let direction = "ltr";
    let titleClass = "bolded ml-2";

    if (i18n.language === "ar") {
      leftLocalized = "right";
      rightLocalized = "left";
      titleClass = "bolded mr-2";
      ml3Localized = "mr-3";
      mr3Localized = "ml-3";
      mr2Localized = "ml-2";
      spanClass = "mr-1 bolded";
      direction = "rtl";
    }

    return (
      <>
        {this.getLoader(this.state.isLoaderVisible)}
        <div
          className="custom-scrollable display-vertically"
          style={{ width: "100%", height: "100%" }}
        >
          {Helpers.getIsIPad() ? (
            <div className="MobileTabHeader">
              <div
                className={titleClass + " MobileTabHeaderTitle"}
                style={{ textAlign: leftLocalized }}
              >
                {this.props.t("portfolioTitle")}
              </div>
              <hr className="no-margin-no-padding mt-2" />
            </div>
          ) : null}
          <div>
            {/* <hr className="no-margin-no-padding" /> */}
            <div
              className="bg-grey"
              dir={direction}
              style={{ width: "100%", display: "flex" }}
            >
              <div className="LeftSideHeader">
                <div
                  className={"mt-2 mb-2 " + ml3Localized}
                  dir={direction}
                  style={{ display: "flex", float: leftLocalized }}
                >
                  <div style={{ display: "flex" }}>
                    <div
                      className={"pt-2 " + mr2Localized + " margin-top-label"}
                      style={{ float: leftLocalized }}
                    >
                      <strong className="lableCustomized">
                        {i18n.t("account")}
                      </strong>
                    </div>
                    <select
                      className="sub-header-dropdown buy-order-input mt-1 margin-top"
                      name="accountNumberPortfolio"
                      id="accountNumberPortfolio"
                      defaultValue="DEFAULT"
                      value={this.state.selectedAccount.ClientID}
                      onChange={(e) => this.onChangeAccount(e, true)}
                    >
                      {this.state.accounts.map((obj) => (
                        <option key={obj.ClientID} value={obj.ClientID}>
                          {
                            this.props.i18n.language === "ar"
                              ? obj.ClientNameA || ""
                              : obj.ClientNameE ||  ""
                         }
                        </option>
                      ))}                   

                      {/* <option value="-1">{i18n.t("AllAccounts")}</option> */}
                      {/* <option value="-1">{this.props.t("all")}</option> we will stop it for now until we found a solution in signalR */}
                    </select>
                  </div>
                </div>
                <div style={{ paddingBlock: "4px" }}>
                  <button
                    title={i18n.t("refresh")}
                    className="edit-btn-grid"
                    disabled={this.state.RefreachRequest}
                    onClick={(e) => {
                      if (!this.state.RefreachRequest) {
                        this.setState(
                          {
                            IsPortfolioPopulited: false,
                            RefreachRequest: true,
                          },
                          () => {
                            // this.callsignalRPortfolio()

                            // this.callGetPortfolioAndAccSum(
                            //   this.state.selectedAccount.MainClientID,
                            //   this.state.selectedAccount.ClientID
                            // );
                            this.callRefreachRequest(
                              this.state.selectedAccount.MainClientID,
                              this.state.selectedAccount.ClientID
                            );
                          }
                        );
                      }
                    }}
                    style={{ marginTop: "0px" }}
                  >
                    <ArrowRepeat size={20} />
                  </button>
                </div>
              </div>
              <div className="RightSideHeader">
                <button
                  title={i18n.t("PrintPDF")}
                  className="edit-btn-grid PrintPDF"
                  onClick={this.generatePPFReport}
                  style={{ paddingTop: "7px" }}
                >
                  <FileEarmarkPdf size={20} />
                </button>
              </div>
            </div>
          </div>
          {/* Section AgGrid */}
          <div className={agGridClass} style={this.state.style}>
            <AgGridReact
              onColumnVisible={this.onColumnVisible}
              getContextMenuItems={this.getContextMenuItems}
              rowHeight={this.state.rowHeight}
              rowData={this.state.rowData}
              getRowId={(params) => params.data.Symbol}
              columnDefs={this.state.columnDefs}
              enableCellChangeFlash={true}
              defaultColDef={this.state.defaultColDef}
              animateRows={true}
              onGridReady={this.onGridReady}
              popupParent={this.state.popupParent}
              asyncTransactionWaitMillis={50}
              enableRtl={this.state.enableRtl}
              enableBrowserTooltips={true}
              // onCellDoubleClicked={this.onCellDoubleClicked}
              onRowClicked={this.onRowClicked}
              overlayLoadingTemplate={
                '<span className="ag-overlay-loading-center" id="ag-loading_data">' +
                this.props.t("ag-overlay-noRow-center") +
                "</span>"
              }
              overlayNoRowsTemplate={
                '<span className="ag-overlay-NoRows-center" id="ag-NoRows">' +
                this.props.t("ag-overlay-noRow-center") +
                "</span>"
              }
            ></AgGridReact>
          </div>
          {/* Section Total */}
          <div
            className="mt-1 mb-1 Laptop-Section-Total-Portfolio"
            style={{ direction: this.dir }}
          >
            <div className={ml3Localized + " Section-Total-Portfolio"}>
              <div>
                <div style={{ float: leftLocalized }}>
                  <strong style={{ fontWeight: "bold" }}>
                    {" "}
                    {this.props.t("total")}:
                  </strong>
                </div>
              </div>
              <br></br>
              {/* <div className="order-horizontal-separator" style={{ float: "left" , color: "blue" }}></div> */}
              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("holdingCostInPortfolio")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalHoldingCost}
                </div>
              </div>
              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>
              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("marketvalue")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalMarketValue}
                </div>
              </div>
              {/* <div className="order-horizontal-separator" style={{ float: "left" }}></div> */}
            </div>
            <div className={ml3Localized + " Section-Total-Portfolio"}>
              {/* <div >
                                <div style={{ float: leftLocalized }}>
                                    <strong> {this.props.t("expectedSellComm")}</strong>
                                </div>
                                <div style={{ float: rightLocalized }}>
                                    {totalExpectedSellComm}
                                </div>
                            </div>
                            <div className="order-horizontal-separator" style={{ float: "left" }}></div> */}

              <div style={{ paddingTop: "17px" }}>
                <div style={{ float: leftLocalized }}>
                  <strong>{this.props.t("realizedpl")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    color: totalRealizedPLColor,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalRealizedPL}
                </div>
              </div>

              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>

              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("expectedpl")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    color: totalExpectedPLColor,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalExpectedPL}
                </div>
              </div>
              {/* <div className="order-horizontal-separator" style={{ float: "left" }}></div> */}
            </div>
            <div
              className={ml3Localized + " Section-Total-Portfolio"}
              style={{ marginRight: "1rem" }}
            >
              <div style={{ paddingTop: "17px" }}>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("expectedplperc")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    color: totalExpectedPLpercColor,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalExpectedPLperc} %
                </div>
              </div>

              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>
              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("netpl")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalNetPL}
                </div>
              </div>
              {/* <div className="order-horizontal-separator" style={{ float: "left" }}></div> */}

              {/* <div >
                                <div style={{ float: leftLocalized }}>
                                    <strong> {this.props.t("pl")}</strong>
                                </div>
                                <div style={{ float: rightLocalized, color: totalPLColor }}>
                                    {totalPL}
                                </div>
                            </div>
                            <div className="order-horizontal-separator" style={{ float: "left" }}></div> */}
            </div>
            {/* <div className={mr3Localized} style={{ fontSize: "1.0rem", float: leftLocalized, direction: direction }}>
                            {this.props.t("total")}:
                        </div>
                        <div>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }} >
                                {this.props.t("holdingCostInPortfolio")}:
                                <span className={spanClass} style={{ color: totalHoldingCostColor, float: rightLocalized }}>{totalHoldingCost}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("marketvalue")}:
                                <span className={spanClass} style={{ color: totalMarketValueColor, float: rightLocalized }}>{totalMarketValue}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("pl")}:
                                <span className={spanClass} style={{ color: totalPLColor, float: rightLocalized }}>{totalPL}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("realizedpl")}:
                                <span className={spanClass} style={{ color: totalRealizedPLColor, float: rightLocalized }}>{totalRealizedPL}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("expectedpl")}:
                                <span className={spanClass} style={{ color: totalExpectedPLColor, float: rightLocalized }}>{totalExpectedPL}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("expectedSellComm")}:
                                <span className={spanClass} style={{ color: totalExpectedSellCommColor, float: rightLocalized }}>{totalExpectedSellComm}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("netpl")}:
                                <span className={spanClass} style={{ color: totalNetPLColor, float: rightLocalized }}>{totalNetPL}</span>
                            </span>
                            <span className={mr3Localized} style={{ float: leftLocalized, direction: direction }}>
                                {this.props.t("netPortfolioValue")}:
                                <span className={spanClass} style={{ color: totalNetPortfolioColor, float: rightLocalized }}>{totalNetPortfolio}</span>
                            </span>
                        </div> */}
          </div>

          {/* Section Total Mobile */}
          <div
            className="mt-1 mb-1  Mobile-Section-Total-Portfolio"
            style={{ direction: this.dir }}
          >
            <div className={" Section-Total-Portfolio"}>
              <div>
                <div style={{ float: leftLocalized }}>
                  <strong style={{ fontWeight: "bold" }}>
                    {" "}
                    {this.props.t("total")}:
                  </strong>
                </div>
              </div>
              <br></br>

              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("holdingCostInPortfolio")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalHoldingCost}
                </div>
              </div>
              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>
              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("marketvalue")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalMarketValue}
                </div>
              </div>

              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>

              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("netpl")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalNetPL}
                </div>
              </div>
            </div>
            <div className={" Section-Total-Portfolio"}>
              <div className="Mobile-totalRealizedPL">
                <div style={{ float: leftLocalized }}>
                  <strong>{this.props.t("realizedpl")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    color: totalRealizedPLColor,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalRealizedPL}
                </div>
              </div>

              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>

              <div>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("expectedpl")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    color: totalExpectedPLColor,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalExpectedPL}
                </div>
              </div>

              <div
                className="order-horizontal-separator"
                style={{ float: "left" }}
              ></div>

              <div style={{ paddingTop: "17px" }}>
                <div style={{ float: leftLocalized }}>
                  <strong> {this.props.t("expectedplperc")}</strong>
                </div>
                <div
                  style={{
                    float: rightLocalized,
                    color: totalExpectedPLpercColor,
                    unicodeBidi: "plaintext",
                    paddingInline: "4px",
                  }}
                >
                  {totalExpectedPLperc} %
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    accounts: state.accounts,
    signalr_connection: state.signalr_connection,
    isDarkMode: state.isDarkMode,
    OrderIsUpdated: state.OrderIsUpdated,
    ClientIDOrderIsUpdated: state.ClientIDOrderIsUpdated,
    //MarketWatchDatafeed: state.MarketWatchDatafeed,
    portfolioDataFirstReq: state.portfolioDataFirstReq,
    symbols: state.symbols,
    portfolioData: state.portfolioData,
    isSubscribedSymbolsChanged: state.isSubscribedSymbolsChanged,
    SymbolToBesubscribed: state.SymbolToBesubscribed,
    SelectedAccountSummaries: state.SelectedAccountSummaries,
    PreferredAccount: state.PreferredAccount,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    changeSymbol: (
      symbolSelected,
      orderTypeSelected,
      BidPriceOrderPopUP,
      BidVolumeOrderPopUP,
      OfferPriceOrderPopUP,
      OfferVolumeOrderPopUP,
      PopulatedRiskManagement
    ) => {
      dispatch({
        type: actions.SYMBOL_CHANGED,
        payload: {
          symbolSelected: symbolSelected,
          orderTypeSelected: orderTypeSelected,
          BidPriceOrderPopUP: BidPriceOrderPopUP,
          BidVolumeOrderPopUP: BidVolumeOrderPopUP,
          OfferPriceOrderPopUP: OfferPriceOrderPopUP,
          OfferVolumeOrderPopUP: OfferVolumeOrderPopUP,
          PopulatedRiskManagement: PopulatedRiskManagement,
        },
      });
    },
    setOrderIsUpdated: (OrderIsUpdated, ClientIDOrderIsUpdated) => {
      dispatch({
        type: actions.ORDER_IS_UPDATED,
        payload: {
          OrderIsUpdated: OrderIsUpdated,
          ClientIDOrderIsUpdated: ClientIDOrderIsUpdated,
        },
      });
    },
    setSelectedAccountFromPortfolioWorkspace: (
      selectedAccountFromPortfolioWorkspace
    ) => {
      dispatch({
        type: actions.SELECTED_ACCOUNT_FROM_PORTFOLIO_WORKSPACE,
        payload: {
          selectedAccountFromPortfolioWorkspace:
            selectedAccountFromPortfolioWorkspace,
        },
      });
    },
    SET_SELECT_SYMBOL_FROM_PORTFOLIO: (
      selectedSymbolFromPortfolio,
      Comp_IDFromPortfolio
    ) => {
      dispatch({
        type: actions.SET_SELECT_SYMBOL_FROM_PORTFOLIO,
        payload: {
          selectedSymbolFromPortfolio: selectedSymbolFromPortfolio,
          Comp_IDFromPortfolio: Comp_IDFromPortfolio,
        },
      });
    },
    SET_PORTFOLIO_Data: (portfolioData, totalMarketValue) => {
      dispatch({
        type: actions.SET_PORTFOLIO_Data,
        payload: {
          portfolioData: portfolioData,
          totalHoldingCost: totalMarketValue,
        },
      });
    },
    SYBMOL_QTY_TO_SELL: (Symbol, Qty, ClientID, Exchange, CustodianId) => {
      dispatch({
        type: actions.SYBMOL_QTY_TO_SELL,
        payload: {
          Symbol: Symbol,
          Qty: Qty,
          ClientID: ClientID,
          Exchange: Exchange,
          CustodianId: CustodianId,
        },
      });
    },
    setSelectedAccountSummaries: (SelectedAccountSummaries) => {
      dispatch({
        type: actions.Selected_Account_Summaries,
        payload: {
          SelectedAccountSummaries: SelectedAccountSummaries,
        },
      });
    },
    setSymbolToSub: (ScreenID, Symbol) => {
      dispatch({
        type: actions.SET_SYMBOLS_TO_SUBSCRIBED,
        payload: {
          ScreenID: ScreenID,
          Symbol: Symbol,
        },
      });
    },
    setFirstTimePortfolioCall: (portfolioDataFirstReq) => {
      dispatch({
        type: actions.PORTFOLIO_FIRST_REQUEST,
        payload: {
          portfolioDataFirstReq: portfolioDataFirstReq,
        },
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(withTranslation(null, { withRef: true })(PortfolioFromDB));
